import { useQuery } from '@tanstack/react-query'
import { getTodaysBookings } from '@/services/bookingApi'
import type { Booking } from '@/types'

interface UseTodaysBookingsReturn {
  bookings: Booking[]
  isLoading: boolean
  error: Error | null
}

export function useTodaysBookings(): UseTodaysBookingsReturn {
  const {
    data: bookings = [],
    isLoading,
    error,
  } = useQuery<Booking[], Error>({
    queryKey: ['todaysBookings'],
    queryFn: () => getTodaysBookings(),
    refetchInterval: 60000, // 60 seconds - for time marker accuracy
  })

  return {
    bookings,
    isLoading,
    error,
  }
}
